<mat-toolbar>
  <mat-toolbar-row>
    <button mat-icon-button [matMenuTriggerFor]="menu" [disableRipple]="true"
      data-e2e="tralalere-bar-menu">
      <mat-icon svgIcon="trala_btn"></mat-icon>
    </button>
    <mat-menu #menu="matMenu" backdropClass="tralalere-bar" class="tralabar">
      @for (link of links; track link) {
        <button mat-menu-item (click)="goToSite(link.get('href'))" data-e2e="tralalere-go-to">
          @if (displayTralabarIcons) {
            <mat-icon >web_asset</mat-icon>
          }
          <span>{{ link.get('label') | translate }}</span>
        </button>
      }
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>
